import {
	Anchor,
	AnchorIcon,
	AnchorWrapper,
	ItemWithLabelWrapper,
	Label,
} from './LinkWithItem.styles';
import { IconButton, SvgIconTypeMap } from '@mui/material';

import { OverridableComponent } from '@mui/material/OverridableComponent';
import React from 'react';
import createAndClickAnchor from '@Utils/createAndClickAnchor';

interface Download {
	url?: string;
	data?: Blob;
	fileName: string;
}

interface ItemsProps {
	label?: React.ReactNode | string;
	value: React.ReactNode | string;
	link?: string;
	download?: Download;
	target?: React.HTMLAttributeAnchorTarget;
	// eslint-disable-next-line @typescript-eslint/ban-types
	Icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
	linkStyling?: boolean;
	onAnchorClick?: () => void;
	disabled?: boolean;
}

const LinkWithLabel = ({
	label,
	value,
	link,
	Icon,
	download,
	target,
	linkStyling,
	onAnchorClick,
	disabled,
}: ItemsProps) => {
	const handleClicked =
		onAnchorClick ||
		(() =>
			createAndClickAnchor({
				download,
				link,
				target,
			}));
	return (
		<ItemWithLabelWrapper className={disabled ? 'disabled' : ''}>
			<Label>{label}</Label>
			<AnchorIcon>
				<Anchor linkStyling={linkStyling} onClick={handleClicked}>
					{value}
				</Anchor>
				<AnchorWrapper>
					{Icon ? (
						<IconButton
							size="small"
							onClick={handleClicked}
							style={{ transform: 'scale(.6)' }}>
							<Icon color="primary" />
						</IconButton>
					) : null}
				</AnchorWrapper>
			</AnchorIcon>
		</ItemWithLabelWrapper>
	);
};

LinkWithLabel.defaultProps = {
	target: '_blank',
	linkStyling: true,
};
export default LinkWithLabel;
